import React from 'react';

export default ({ className, ...rest }) => (
  <span className={className} {...rest}>
    <svg x="0px" y="0px" viewBox="0 0 51.3 51.97">
    <g>
      <path d="M42.88,8.76c-4.42-4.42-10.5-7.17-17.23-7.17c-6.73,0-12.81,2.75-17.23,7.17c-4.42,4.42-7.17,10.5-7.17,17.23
        c0,6.73,2.75,12.81,7.17,17.23c4.41,4.42,10.5,7.17,17.23,7.17c6.73,0,12.81-2.75,17.23-7.17c4.42-4.41,7.17-10.49,7.17-17.23
        C50.04,19.25,47.29,13.17,42.88,8.76z M25.65,46.33c-5.65,0-10.71-2.24-14.4-5.94c-3.69-3.69-5.94-8.76-5.94-14.4
        s2.24-10.71,5.94-14.41c3.69-3.69,8.76-5.94,14.4-5.94s10.71,2.24,14.41,5.94c3.69,3.69,5.94,8.76,5.94,14.41
        s-2.24,10.71-5.94,14.4C36.36,44.08,31.3,46.33,25.65,46.33z"/>
      <path d="M27.39,19.54c-0.36-0.36-0.87-0.58-1.38-0.58c-0.51,0-1.08,0.22-1.45,0.58l-7.67,7.67
        c-0.22,0.22-0.36,0.44-0.43,0.65c-0.14,0.29-0.14,0.51-0.14,0.8c0,0.22,0,0.51,0.14,0.72c0.07,0.29,0.22,0.51,0.43,0.73
        c0.36,0.36,0.87,0.58,1.37,0.58c0.51,0,1.09-0.22,1.45-0.58l6.3-6.3l6.23,6.3c0.43,0.36,0.94,0.58,1.45,0.58
        c0.51,0,1.01-0.22,1.38-0.58c0.43-0.44,0.58-0.94,0.58-1.45s-0.14-1.01-0.58-1.45L27.39,19.54z"/>
    </g>
    </svg>
  </span>
);